export enum QR_CODE_READER_ERRORS {
  NOT_ALLOWED_ERROR = 'NotAllowedError',
  UNKNOWN_ERROR = 'UnknownError',
}

// these errors throws qr-code-reader when can't find qr code in the camera view
// and in this case we should do nothing
export const QR_CODE_READER_NOT_ERRORS = ['e', 't']
